import { memo } from "react";
import { Button, ButtonBorder, ButtonTheme } from "../button";
import { Flex } from "../flex";
import { ExternalLink } from "../link";
import { Header, Text } from "../text";
import * as externalLoginCss from "./external-login.module.css";

export const ExternalLogin = memo(function ExternalLogin({
  registerHeader,
  registerSubtext,
  registerLinkText = "Join now",
  onLoginClick,
  onRegisterClick,
  centerSignInText = false,
}: {
  registerHeader?: string | undefined;
  registerSubtext?: string | undefined;
  registerLinkText?: string | undefined;
  onLoginClick?: () => Promise<void>;
  onRegisterClick?: () => Promise<void>;
  centerSignInText?: boolean | undefined;
}) {
  const registerUrl = new URL(window.location.href);
  registerUrl.pathname = "/account/register";
  registerUrl.hash = "";

  const loginUrl = new URL(window.location.href);
  loginUrl.pathname = "/account/login";
  loginUrl.hash = "";

  return (
    <>
      {registerHeader && (
        <Header fontFamily="inherit" fontSize="xs">
          {registerHeader}
        </Header>
      )}
      <Flex dir="column" gap="xl">
        {registerSubtext && <Text fontSize="sm">{registerSubtext}</Text>}
        <Button
          border={ButtonBorder.TRANSPARENT}
          onClick={async () => {
            await onRegisterClick?.();
            window.location.href = registerUrl.toString();
          }}
          theme={ButtonTheme.PRIMARY}
        >
          <Text fontSize="sm">{registerLinkText}</Text>
        </Button>
        <Text
          className={
            centerSignInText ? externalLoginCss.centerSignInText : undefined
          }
          fontSize="sm"
        >
          Already have an account?{" "}
          <ExternalLink
            newTab={false}
            onClick={onLoginClick}
            showIcon={false}
            url={loginUrl.toString()}
          >
            Sign in
          </ExternalLink>
        </Text>
      </Flex>
    </>
  );
});
